import React from 'react'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

export const MailAddrForm = React.createClass({
  getInitialState(){
    return {
      isvalid:false,
      mailaddr: '',
      errmsg: ''
    }
  },

  setMailaddr(e) {
    this.setState({'mailaddr': e.target.value.trim()})
  },

  onsubmit(e) {
    this.props.onsubmit(e, this.state.mailaddr)
  },

  render() {
    const is_valid = (this.state.mailaddr.length) && this.state.mailaddr.match(/^[\w_+-.]+@[\w_+-.]+$/)

    return (
      <form className='modal fade form_userinfo' method='POST' autocomplete>
        <Modal show={this.props.showModal} onHide={this.props.close}>

          <Modal.Header closeButton>
            <Modal.Title>{this.props.caption}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
          <div className="input-group">
            <span className="input-group-addon">メールアドレス</span>
            <input type="text" className="form-control input-mailaddr" placeholder="メールアドレスを入力してください"
             name="mailaddr"
             onChange={this.setMailaddr} autofocus />
          </div>


            <div style={{display: "none"}} className="alert alert-danger" role="alert">{this.state.errmsg}</div>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.props.close}>キャンセル</Button>
            <Button type='submit' className='btn btn-primary' disabled={!is_valid}
              onClick={this.onsubmit}>{this.props.okbutton}</Button>
          </Modal.Footer>

        </Modal>
      </form>
    );
  }
});



// WEBPACK FOOTER //
// ./components/mailaddrform.react.js